var _circle, _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#003B6F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13385_5075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12.916C5 11.1666 5 9.41494 5 7.66561C5.05619 7.50116 5.21256 7.44873 5.35915 7.55598C5.53262 7.67991 5.68898 7.82291 5.85268 7.95875C6.34865 8.37344 6.84706 8.78337 7.34547 9.19806C7.84633 9.61513 8.34718 10.0346 8.8456 10.4564C9.0435 10.6256 9.2414 10.7949 9.44174 10.9617C9.78134 11.2405 10.2065 11.2453 10.5436 10.9617C11.0762 10.516 11.6015 10.0632 12.1366 9.6199C12.6448 9.19568 13.1554 8.77384 13.666 8.34961C13.9519 8.11128 14.2426 7.87534 14.526 7.63463C14.6042 7.5679 14.6824 7.50116 14.7997 7.5107C14.9121 7.52023 14.9805 7.57981 14.9927 7.68706C14.9976 7.71804 14.9951 7.75141 14.9951 7.78239C14.9951 9.45307 14.9878 11.1237 15 12.7944C15.0049 13.3378 14.5749 13.6715 14.0985 13.6715C11.8654 13.6667 9.63231 13.6691 7.39922 13.6691C6.88615 13.6691 6.37308 13.6739 5.85756 13.6667C5.50086 13.6619 5.22966 13.507 5.06108 13.1948C5.01466 13.1043 5.01955 13.0089 5 12.916Z",
    fill: "#003B6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99615 6.33325C11.3668 6.33325 12.7399 6.33325 14.1105 6.33325C14.367 6.33325 14.5869 6.41428 14.7628 6.60018C14.885 6.72888 14.8777 6.84327 14.7384 6.95767C13.678 7.83948 12.6153 8.71891 11.5549 9.6031C11.142 9.9463 10.734 10.2966 10.326 10.6446C10.0817 10.8519 9.89842 10.8519 9.65655 10.6446C8.20773 9.40053 6.7296 8.19221 5.26124 6.96959C5.10243 6.83612 5.0951 6.72411 5.24169 6.57873C5.41516 6.40713 5.62772 6.33325 5.87204 6.33325C7.24756 6.33564 8.62308 6.33325 9.99615 6.33325Z",
    fill: "#003B6F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 6.83325,
    width: 9,
    height: 6.33333,
    rx: 1.5,
    stroke: "#003B6F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13385_5075"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6.33325,
    width: 10,
    height: 7.33333,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.b142affdd0b6d193f5b70e7b6093851a.svg";
export { ForwardRef as ReactComponent };